import DecimalSelect from '../elements/DecimalSelect';

export default function Culture(props) {
    function onClickRating(value) {
        props.setValue(props.culture.id, parseInt(value));
    }
    var options = [];
    const numericValue = props.value !== undefined && props.value !== ''
        ? Number(props.value)
        : undefined;
    for (let i = 1; i <= 7; i++) {
        if (numericValue === i)
            options.push(<span key={i} className="numberSelect selected" onClick={() => { onClickRating(i) }}>{i}</span>);
        else
            options.push(<span key={i} className="numberSelect" onClick={() => { onClickRating(i) }}>{i}</span>);
    }
    return (<>
        <tr className='Culture'>
            <td>
                <div className="Culture">
                    <div className="title">{props.culture.title}</div>
                    <div className="values">
                        <span className="min">{props.culture.min}</span>
                        <span className="rating">
                            <DecimalSelect max="7" value={numericValue} onClickValue={onClickRating} showValidations={props.showValidations} />
                        </span>
                        <span className="max">{props.culture.max}</span>
                    </div>
                </div>
            </td>
        </tr>
    </>
    );
}
